import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'trpx-trust-factor',
  templateUrl: './trust-factor.component.html',
  styleUrls: ['./trust-factor.component.scss'],
})
export class TrustFactorComponent implements OnInit {
  slides: any[] = [];
  groupedSlides: any[][] = [];

  constructor() {
    this.slides = [
      {
        image: './assets/images/Trusted-by-Millions.webp',
        heading: 'Trusted by Millions',
        description:
          '20+ years of expertise, delivering authentic, curated experiences.',
      },
      {
        image: './assets/images/Secure-Payments.webp',
        heading: 'Super Secure Payments',
        description: 'Advanced encryption and fraud protection for 100% safe transactions.',
      },
      {
        image: './assets/images/Verified-Partners.webp',
        heading: 'Verified Partners Only',
        description: 'All attractions and experiences are rigorously vetted.',
      },
      {
        image: './assets/images/Money-Banck.webp',
        heading: 'Money-Back Guarantee',
        description: 'If your ticket isn’t accepted, we refund—no questions asked.',
      },
      {
        image: './assets/images/Authentic-Experiences.webp',
        heading: 'Authentic Experiences',
        description: 'Handpicked tours and activities, from iconic landmarks to hidden gems.',
      },
      {
        image: './assets/images/Official-Partners.webp',
        heading: 'Official Partners',
        description: 'As an official partner of tourism boards & attractions, we offer exclusive access and the best rates.',
      },
      {
        image: './assets/images/Best-Deals.webp',
        heading: 'Best Deals, Guaranteed',
        description: 'Enjoy savings of up to 20% on top-rated experiences worldwide.',
      },
      {
        image: './assets/images/Support-24-7.webp',
        heading: '24/7 Customer Support',
        description: 'Our dedicated team ensures a seamless travel experience.',
      },
      {
        image: './assets/images/Trusted-Globally.webp',
        heading: 'Trusted Globally',
        description: 'Asia’s largest aggregator, connecting you to top attractions in 140+ countries.',
      },
      {
        image: './assets/images/Flexible-Bookings.webp',
        heading: 'Flexible Bookings',
        description: 'Easy cancellation and rescheduling options for worry-free travel.',
      }
    ];
    this.groupSlides();
  }

  ngOnInit(): void {}

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          dots: false,
          variableWidth: false,
        },
      },
    ],
  };

  private groupSlides() {
    this.groupedSlides = [];
    for (let i = 0; i < this.slides.length; i += 2) {
      this.groupedSlides.push(this.slides.slice(i, i + 2));
    }
  }
}
